import discord from "./discord";
import github from "./github";
import instagram from "./instagram";
import less from "./less";
import more from "./more";
import plugin from "./plugin";
import support from "./support";
import twitch from "./twitch";
import youtube from "./youtube";

export default { discord, github, instagram, less, more, plugin, support, twitch, youtube };
